import { render } from "./praReleaseDialog.vue?vue&type=template&id=0d6aa917&scoped=true"
import script from "./praReleaseDialog.vue?vue&type=script&lang=js"
export * from "./praReleaseDialog.vue?vue&type=script&lang=js"

import "./praReleaseDialog.vue?vue&type=style&index=0&id=0d6aa917&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6aa917"]])

export default __exports__